/**
 * Dropdown.tsx
 *
 * This new Dropdown in-houses the basic composed dropdown which defines the span and the dropdown list around it
 * This component has no styling around it and is dependent upon the classes passed to it
 * Migrated from @reach/listbox to @radix-ui/react-select (Reach UI is unmaintained)
 */
import React from "react";

import * as Select from "@radix-ui/react-select";
import classNames from "classnames";

import { DownIcon } from "./icons/DownIcon";

import "./Dropdown.css";

export const Dropdown = ({
  value,
  setValue,
  options,
  defaultLabel,
  wrapperClass = "dropdownWrapper",
  buttonClass = "dropdownButton",
  popoverClass = "dropdownPopover",
  arrowStyle = { color: "white", width: 14, height: 7 },
  disabled,
  isBottomRow = false,
}: {
  defaultLabel?: string;
  value: string | number;
  setValue: (value: string) => void;
  options: { id?: string | number; value: string | number; label: string }[];
  wrapperClass?: classNames.Argument;
  buttonClass?: classNames.Argument;
  popoverClass?: classNames.Argument;
  arrowStyle?: { color?: string; width?: number; height?: number };
  disabled?: boolean;
  isBottomRow?: boolean;
}) => {
  if (!defaultLabel) {
    defaultLabel = options.find(
      (option) => value.toString() === option.value.toString(),
    )?.label;
  }

  return (
    <Select.Root
      disabled={disabled}
      value={value.toString()}
      onValueChange={setValue}
    >
      <Select.Trigger className={classNames(wrapperClass, buttonClass)}>
        <Select.Value>
          <span></span>
          <span>{defaultLabel ?? "Choose an option"}</span>
        </Select.Value>
        <Select.Icon>
          <DownIcon
            width={arrowStyle.width}
            height={arrowStyle.height}
            color={arrowStyle.color}
            className={""}
          />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content
          className={classNames(popoverClass, { raisedPopover: isBottomRow })}
          position="popper"
        >
          <Select.Viewport>
            {options.map((option) => (
              <Select.Item
                key={option.value.toString()}
                value={option.value.toString()}
              >
                <Select.ItemText>{option.label}</Select.ItemText>
              </Select.Item>
            ))}
          </Select.Viewport>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
};
